import React from 'react'
import Select, {components} from 'react-select'
import Icons from '../Icons'
import styled from 'styled-components'

const Container = styled.div`
  padding: 0;
`

const customStyles = {
  control: base => ({
    ...base,
    backgroundColor: '#f3f5fb',
    height: 46,
    border: '1px solid #f3f5fb',
    borderRadius: 6,
    boxSizing: 'border-box',
    '&:hover': {
      borderColor: '#f3f5fb'
    }
  }),

  indicatorSeparator: base => ({
    ...base,
    display: 'none'
  }),
  indicatorsContainer: base => ({
    ...base,
    borderRadius: 4,
    backgroundColor: '#FFF',
    height: 46,
    width: 46,
    boxShadow: '0 1px 6px 0 rgba(51, 149, 254, 0.38)',
    marginTop: -1
  }),
  dropdownIndicator: base => ({
    ...base,
    marginLeft: 8
  })
}

const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <Icons icon="DOWN_ARROW" />
      </components.DropdownIndicator>
    )
  )
}

const ListSelect = props => {
  return (
    <Container>
      <Select
        {...props}
        styles={customStyles}
        components={{DropdownIndicator}}
      />
    </Container>
  )
}

export default ListSelect
